/*
    Dieses Helper-Feature lässt eine Gruppe von Elementen nahtlos entlang der Y-Achse scrollen.
    Statt horizontalLoop also ein verticalLoop.

    Features (vergleichbar mit horizontalLoop):
     - Verwendet yPercent, damit es bei Größenänderungen (z.B. Fenster-Resize) weiter robust bleibt.
     - Sobald ein Element die untere oder obere Grenze erreicht, springt es zurück, um einen Endlos-Effekt zu erzeugen.
     - Config-Objekt kann genutzt werden ({ draggable, center, speed (Standard: 1, ca. 100px/s), paused, repeat, reversed, paddingBottom }).
     - Gibt eine Timeline zurück mit Methoden:
       - next(), previous(), toIndex(), current(), times.
*/
function verticalLoop(items, config) {
	let timeline;
	items = gsap.utils.toArray(items);
	config = config || {};
	gsap.context(() => {
		let onChange = config.onChange,
			lastIndex = 0,
			tl = gsap.timeline({
				repeat: config.repeat,
				onUpdate: onChange && function() {
					let i = tl.closestIndex();
					if (lastIndex !== i) {
						lastIndex = i;
						onChange(items[i], i);
					}
				},
				paused: config.paused,
				defaults: { ease: "none" },
				onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
			}),
			length = items.length,
			startY = items[0].offsetTop,
			times = [],
			heights = [],
			spaceBefore = [],
			yPercents = [],
			curIndex = 0,
			indexIsDirty = false,
			center = config.center,
			pixelsPerSecond = (config.speed || 1) * 100,
			snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
			timeOffset = 0,
			container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
			totalHeight,
			getTotalHeight = () => {
				let last = items[length - 1],
					scaleY = gsap.getProperty(last, "scaleY");
				return (
					last.offsetTop +
					(yPercents[length - 1] / 100) * heights[length - 1] -
					startY +
					spaceBefore[0] +
					last.offsetHeight * scaleY +
					(parseFloat(config.paddingBottom) || 0)
				);
			},
			populateHeights = () => {
				let b1 = container.getBoundingClientRect(), b2;
				items.forEach((el, i) => {
					heights[i] = parseFloat(gsap.getProperty(el, "height", "px"));
					yPercents[i] = snap(
						(parseFloat(gsap.getProperty(el, "y", "px")) / heights[i]) * 100 + gsap.getProperty(el, "yPercent")
					);
					b2 = el.getBoundingClientRect();
					spaceBefore[i] = b2.top - (i ? b1.bottom : b1.top);
					b1 = b2;
				});
				gsap.set(items, {
					yPercent: i => yPercents[i]
				});
				totalHeight = getTotalHeight();
			},
			timeWrap,
			populateOffsets = () => {
				timeOffset = center ? (tl.duration() * (container.offsetHeight / 2)) / totalHeight : 0;
				center &&
				times.forEach((t, i) => {
					times[i] = timeWrap(
						tl.labels["label" + i] +
						(tl.duration() * heights[i]) / 2 / totalHeight -
						timeOffset
					);
				});
			},
			getClosest = (values, value, wrap) => {
				let i = values.length,
					closest = 1e10,
					index = 0,
					d;
				while (i--) {
					d = Math.abs(values[i] - value);
					if (d > wrap / 2) {
						d = wrap - d;
					}
					if (d < closest) {
						closest = d;
						index = i;
					}
				}
				return index;
			},
			populateTimeline = () => {
				let i, item, curY, distanceToStart, distanceToLoop;
				tl.clear();
				for (i = 0; i < length; i++) {
					item = items[i];
					curY = (yPercents[i] / 100) * heights[i];
					distanceToStart = item.offsetTop + curY - startY + spaceBefore[0];
					distanceToLoop = distanceToStart + heights[i] * gsap.getProperty(item, "scaleY");

					tl.to(
						item,
						{
							yPercent: snap(((curY - distanceToLoop) / heights[i]) * 100),
							duration: distanceToLoop / pixelsPerSecond
						},
						0
					)
						.fromTo(
							item,
							{
								yPercent: snap(
									((curY - distanceToLoop + totalHeight) / heights[i]) * 100
								)
							},
							{
								yPercent: yPercents[i],
								duration:
									(curY - distanceToLoop + totalHeight - curY) / pixelsPerSecond,
								immediateRender: false
							},
							distanceToLoop / pixelsPerSecond
						)
						.add("label" + i, distanceToStart / pixelsPerSecond);
					times[i] = distanceToStart / pixelsPerSecond;
				}
				timeWrap = gsap.utils.wrap(0, tl.duration());
			},
			refresh = deep => {
				let progress = tl.progress();
				tl.progress(0, true);
				populateHeights();
				deep && populateTimeline();
				populateOffsets();
				deep && tl.draggable && tl.paused()
					? tl.time(times[curIndex], true)
					: tl.progress(progress, true);
			},
			onResize = () => refresh(true),
			proxy;

		gsap.set(items, { y: 0 });
		populateHeights();
		populateTimeline();
		populateOffsets();
		window.addEventListener("resize", onResize);

		function toIndex(index, vars) {
			vars = vars || {};
			// always go in the shortest direction
			if (Math.abs(index - curIndex) > length / 2) {
				index += index > curIndex ? -length : length;
			}
			let newIndex = gsap.utils.wrap(0, length, index),
				time = times[newIndex];
			if (time > tl.time() !== index > curIndex && index !== curIndex) {
				time += tl.duration() * (index > curIndex ? 1 : -1);
			}
			if (time < 0 || time > tl.duration()) {
				vars.modifiers = { time: timeWrap };
			}
			curIndex = newIndex;
			vars.overwrite = true;
			gsap.killTweensOf(proxy);
			return vars.duration === 0 ? tl.time(timeWrap(time)) : tl.tweenTo(time, vars);
		}

		tl.toIndex = (index, vars) => toIndex(index, vars);
		tl.closestIndex = setCurrent => {
			let index = getClosest(times, tl.time(), tl.duration());
			if (setCurrent) {
				curIndex = index;
				indexIsDirty = false;
			}
			return index;
		};
		tl.config = config;
		tl.refresh = () => refresh(true);
		tl.dispose = () => {
			window.removeEventListener("resize", onResize);
		};
		tl.current = () => (indexIsDirty ? tl.closestIndex(true) : curIndex);
		tl.next = vars => toIndex(tl.current() + 1, vars);
		tl.previous = vars => toIndex(tl.current() - 1, vars);
		tl.times = times;
		tl.progress(1, true).progress(0, true);

		if (config.reversed) {
			tl.vars.onReverseComplete();
			tl.reverse();
		}

		// Make it draggable vertically if Draggable is provided
		if (config.draggable && typeof Draggable === "function") {
			proxy = document.createElement("div");
			let wrap = gsap.utils.wrap(0, 1),
				ratio,
				startProgress,
				draggable,
				lastSnap,
				initChangeY,
				wasPlaying,
				align = () => tl.progress(wrap(startProgress + (draggable.startY - draggable.y) * ratio)),
				syncIndex = () => tl.closestIndex(true);

			typeof InertiaPlugin === "undefined" &&
			console.warn("InertiaPlugin wird benötigt, um inertia zu verwenden.");

			draggable = Draggable.create(proxy, {
				trigger: items[0].parentNode,
				type: "y",
				throwResistance: 1000,
				maxDuration: 0.8,
				minDuration: 0.2,
				velocityScale: 0.6,
				onPressInit() {
					let timestamp = performance.now();
					let oldY = this.y;
					let wasThrowingBefore = this.isThrowing;
					gsap.killTweensOf(tl);
					wasPlaying = !tl.paused();
					tl.pause();
					startProgress = tl.progress();
					refresh();
					ratio = 1 / totalHeight;

					// Set proxy.y FIRST before reading this.y to prevent extreme initChangeY values
					// Use explicit "px" unit to override global gsap.config({units: {y:"vw"}})
					let calculatedY = startProgress / -ratio;
					gsap.set(proxy, {y: calculatedY + "px"});
					this.update();  // Force Draggable to sync its internal y value
					let y = this.y;

					let difference = oldY - y;
					let didLoopWrap = Math.abs(difference) > totalHeight / 2;  // Detect loop wrap

					initChangeY = (startProgress / -ratio) - y;
					console.log("🔵 onPressInit [" + timestamp.toFixed(2) + "ms]: " + [
						"startProgress=" + startProgress,
						"ratio=" + ratio,
						"calculatedY=" + calculatedY,
						"oldY=" + oldY,
						"newY=" + y,
						"initChangeY=" + initChangeY,
						"difference=" + difference,
						"didLoopWrap=" + didLoopWrap,
						"totalHeight=" + totalHeight,
						"startY=" + this.startY,
						"wasThrowing=" + wasThrowingBefore
					].join(", "));
				},
				onDrag: align,
				onThrowUpdate: align,
				overshootTolerance: 0,
				inertia: true,
				snap(value) {
					let timestamp = performance.now();
					console.log("🟡 snap [" + timestamp.toFixed(2) + "ms]: value=" + value + ", startProgress=" + startProgress + ", ratio=" + ratio + ", thisY=" + this.y);

					let dragDistance = draggable.startY - draggable.y;
					let actualDistance = Math.abs(dragDistance);
					let checkValue = Math.abs(startProgress / -ratio - this.y);

					if (checkValue < 10) {
						let earlyReturnTime = performance.now();
						console.log("🟡 snap - early return [" + earlyReturnTime.toFixed(2) + "ms]: " + [
							"checkValue=" + checkValue,
							"returning=" + (lastSnap + initChangeY)
						].join(", "));
						return lastSnap + initChangeY;
					}

					// CRITICAL FIX 1: If initChangeY is very large (loop wrap during throw),
					// the velocity will be inflated. Detect and correct this.
					// LOWERED THRESHOLD from 100 to 50 to catch more cases
					let adjustedValue = value;
					let wasInitChangeYAdjusted = false;
					if (Math.abs(initChangeY) > 50) {
						adjustedValue = draggable.startY - this.y;
						wasInitChangeYAdjusted = true;
						console.log("⚠️ LARGE initChangeY DETECTED: " + initChangeY + ", using adjustedValue=" + adjustedValue + " instead of " + value);
					}

					// Calculate valueVsDistance for logging purposes
					let valueVsDistance = actualDistance > 0 ? Math.abs(adjustedValue / actualDistance) : 0;

					let time = -(adjustedValue * ratio) * tl.duration(),
						wrappedTime = timeWrap(time),
						closestIndex = getClosest(times, wrappedTime, tl.duration()),
						snapTime = times[closestIndex],
						dif = snapTime - wrappedTime;

					let wasAdjusted = Math.abs(dif) > tl.duration() / 2;
					if (wasAdjusted) {
						dif += dif < 0 ? tl.duration() : -tl.duration();
					}

					lastSnap = (time + dif) / tl.duration() / -ratio;

					let snapEndTime = performance.now();
					console.log("🟢 snap [" + snapEndTime.toFixed(2) + "ms]: " + [
						"value=" + value,
						"adjustedValue=" + adjustedValue,
						"dragDistance=" + dragDistance,
						"actualDistance=" + actualDistance,
						"thisY=" + this.y,
						"startY=" + draggable.startY,
						"time=" + time,
						"wrappedTime=" + wrappedTime,
						"closestIndex=" + closestIndex,
						"snapTime=" + snapTime,
						"dif=" + dif,
						"wasAdjusted=" + wasAdjusted,
						"lastSnap=" + lastSnap,
						"tlDuration=" + tl.duration(),
						"tlProgress=" + tl.progress(),
						"valueVsDistance=" + valueVsDistance,
						"initChangeY=" + initChangeY,
						"wasInitChangeYAdjusted=" + wasInitChangeYAdjusted
					].join(", "));
					return lastSnap;
				},
				onRelease() {
					let timestamp = performance.now();
					syncIndex();
					console.log("🔴 onRelease [" + timestamp.toFixed(2) + "ms]: " + [
						"isThrowing=" + draggable.isThrowing,
						"y=" + draggable.y,
						"startY=" + draggable.startY,
						"dragDistance=" + (draggable.startY - draggable.y)
					].join(", "));
					draggable.isThrowing && (indexIsDirty = true);
				},
				onThrowComplete: () => {
					let timestamp = performance.now();
					console.log("🟣 onThrowComplete [" + timestamp.toFixed(2) + "ms]: " + [
						"finalY=" + draggable.y,
						"progress=" + tl.progress()
					].join(", "));
					syncIndex();
					config.complete && config.complete();
				}
			})[0];
			tl.draggable = draggable;
		}

		tl.closestIndex(true);
		lastIndex = curIndex;
		onChange && onChange(items[curIndex], curIndex);
		timeline = tl;
		return () => window.removeEventListener("resize", onResize);
	});
	return timeline;
}

const clearTimeline = (...timelines) => {
	timelines.forEach((tl) => {
		if (!tl) return;
		tl.kill();
		tl.progress(0).kill();
		let childrens = tl.getChildren(true, true, false);
		childrens.forEach((child) => {
			gsap.set(child._targets, { clearProps: true });
			child.kill();
		});
	});
};

/**
 * Bietet ein unendliches Scroll-Verhalten entlang der Y-Achse per GSAP.
 *
 * @property {import('vue').Component} component - Die Vue-Komponente.
 * @property {HTMLElement} lane - Lane-Element.
 * @property {HTMLElement[]} originalChilds - Ursprüngliche Lane-Elemente vor Klonen.
 * @property {HTMLElement[]} currentChilds - Alle aktuellen Lane-Elemente (inkl. Klone).
 * @property {HTMLElement|null} activeElement - Aktuell aktives (zentriertes) Element.
 * @property {GSAPTimeline|null} loop - GSAP-Loop-Timeline.
 * @method init - Baut das Plugin auf, steuert responsives Neuladen.
 * @method populateBoxes - Klont Lane-Elemente bis zum nötigen Overflow.
 * @method initBoxes - Initialisiert GSAP-Loop und Events.
 * @method disposeBoxes - Räumt Loop auf und entfernt Klone.
 * @method bindEvents - Fügt Eventlistener für Hover/Click hinzu.
 * @method unbindEvents - Entfernt Eventlistener.
 * @method onMouseEnter - Verlangsamt Loop bei Hover.
 * @method onMouseLeave - Beschleunigt Loop erneut beim Verlassen.
 * @method complete - Callback nach Animation.
 * @method next - Nächstes Item.
 * @method prev - Vorheriges Item.
 * @method play - Platzhalter.
 * @method pause - Platzhalter.
 * @method isPaused - Platzhalter.
 * @method destroy - Entfernt die ganze Logik.
 */
export default class LaneInfinityY {
	constructor(component) {
		this.component = component;
		this.lane = this.component.lane;
		this.loop = null;
		this.itemCounter = 0;
		this.index = 0;
		this.realIndex = 0;
		this.originalChilds = [...gsap.utils.toArray(this.component.childs)];
		this.currentChilds = [];
		this.activeElement = null;
		this.autoScrollStop = false;
		this.init();
	}

	init() {
		gsap.registerPlugin(Draggable);
		gsap.registerPlugin(InertiaPlugin);

		this.originalChilds.forEach((origBox, i) => {
			origBox.dataset.laneIndex = i;
			origBox.dataset.laneRealIndex = this.itemCounter++;
		});

		this.populateBoxes();

		let resizeTimeout;
		window.addEventListener("resize", () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				this.populateBoxes();
			}, 250);
		});
	}

	populateBoxes() {
		const wrapperHeight = this.lane.offsetHeight;

		if (this.currentChilds.length === 0) {
			this.currentChilds = [...gsap.utils.toArray(this.component.childs)];
			this.initBoxes();
		}

		const boxHeight = this.currentChilds[0].offsetHeight;
		let totalHeight = this.currentChilds.reduce((sum, box) => sum + box.offsetHeight, 0);
		let itemsCount = this.currentChilds.length;

		while (totalHeight < wrapperHeight + boxHeight) {
			this.originalChilds.forEach((origBox, i) => {
				const clone = origBox.cloneNode(true);
				clone.dataset.laneIndex = i;
				clone.dataset.laneRealIndex = this.itemCounter++;
				this.lane.appendChild(clone);
				this.currentChilds.push(clone);
				totalHeight += clone.offsetHeight;
			});
		}

		if (itemsCount < this.currentChilds.length) {
			this.disposeBoxes();
			this.initBoxes();
		}
	}

	disposeBoxes() {
		this.unbindEvents();
		if (this.loop) {
			this.loop.dispose();
			clearTimeline(this.loop);
			this.loop = null;
		}
		if (this.activeElement) {
			this.activeElement = null;
		}
		this.lane.querySelectorAll(".infinity-active").forEach(el => el.classList.remove("infinity-active"));
	}

	bindEvents() {
		const lane = this.component.lane;
		this.onMouseEnter = this.onMouseEnter.bind(this);
		this.onMouseLeave = this.onMouseLeave.bind(this);
		this.complete = this.complete.bind(this);

		if (this.component.autoScrollItemHoverPause) {
			lane.addEventListener("mouseenter", this.onMouseEnter);
			lane.addEventListener("mouseleave", this.onMouseLeave);
		}

		if (this.component.itemsClickToCenterEnabled) {
			this.currentChilds.forEach((box, i) => {
				box._clickHandler = () =>
					this.loop.toIndex(i, {
						duration: 0.9,
						ease: "power3.out",
						onComplete: this.complete
					});
				box.addEventListener("click", box._clickHandler);
			});
		}
	}

	unbindEvents() {
		const lane = this.component.lane;
		lane.removeEventListener("mouseenter", this.onMouseEnter);
		lane.removeEventListener("mouseleave", this.onMouseLeave);

		this.currentChilds.forEach(box => {
			box.removeEventListener("click", box._clickHandler);
			delete box._clickHandler;
		});
	}

	initBoxes() {
		this.loop = verticalLoop(this.currentChilds, {
			repeat: -1,
			speed: this.component.autoScrollSpeed * 0.1,
			reversed: this.component.autoScrollReversed,
			paused: !this.component.autoScroll,
			draggable: true,
			center: true,
			onChange: (element, index) => {
				const laneIndex = element.dataset.laneIndex;
				const realIndex = element.dataset.laneRealIndex;

				this.activeElement && this.activeElement.classList.remove("infinity-active");
				element.classList.add("infinity-active");
				this.activeElement = element;
				this.index = laneIndex;
				this.realIndex = realIndex;
			},
			complete: () => this.complete()
		});
		this.bindEvents();
	}

	onMouseEnter() {
		this.component.autoScrollItemIsPausedMouseOver = true;
		if (this.autoScrollStop) return;
		gsap.to(this.loop, {
			timeScale: 0,
			duration: 1.3,
			ease: "power2.out"
		});
	}

	onMouseLeave() {
		this.component.autoScrollItemIsPausedMouseOver = false;
		if (this.autoScrollStop) return;

		if (this.component.autoScrollItemHoverPause) {
			if (this.component.autoScrollReversed) {
				gsap.to(this.loop, {
					timeScale: -1,
					duration: 1.3,
					ease: "power2.out"
				});
			} else {
				gsap.to(this.loop, {
					timeScale: 1,
					duration: 1.3,
					ease: "power2.out"
				});
			}
		}
	}

	getRealIndex() {
		return this.realIndex;
	}

	getIndex() {
		return this.index;
	}

	complete() {
		if (this.component.autoScroll) {
			if (this.component.autoScrollReversed) {
				this.loop.reverse();
			} else {
				this.loop.play();
			}
		}
	}

	next() {
		if (this.loop)
			this.loop.next({
				duration: 0.9,
				ease: "power3.out",
				onComplete: this.complete
			});
	}

	prev() {
		if (this.loop)
			this.loop.previous({
				duration: 0.9,
				ease: "power3.out",
				onComplete: this.complete
			});
	}

	play() {
		// Placeholder
	}

	pause() {
		// Placeholder
	}

	isPaused() {
		// Placeholder
	}

	startAutoscroll() {
		this.autoScrollStop = false;
	}

	stopAutoscroll() {
		this.autoScrollStop = true;
	}

	destroy() {
		this.disposeBoxes();
	}
}
